import React, { FunctionComponent, useState, useContext } from "react";
import Modal from "shared/components/Modal/Modal";
import { useForm } from "react-hook-form";

import Button from "shared/components/Buttons/Button";
import InputList from "shared/components/InputList/InputList";
import styles from "./AddChallengeModal.module.scss";
import wrapLocalLoader from "shared/utils/wrapLocalLoader";
import apiCalls from "shared/utils/apiCalls";
import AppContext from "context/AppContext";
import { ReducerTypes } from "shared/types/reducerTypes";
import { useHistory } from "react-router-dom";
import Input from "shared/components/Input/Input";

const AddChallengeModal: FunctionComponent<{
  open: boolean;
  closeModal: () => void;
}> = ({ open, closeModal }) => {
  const { register, control, handleSubmit } = useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const { dispatch } = useContext(AppContext);

  const history = useHistory();

  const getChallenges = async () => {
    const res = await apiCalls({
      method: "get",
      url: "/challenges",
    });

    if (res) {
      dispatch({
        type: ReducerTypes.fetchChallenges,
        payload: { value: res.data },
      });
    }
  };

  const onSubmit = async (data: any) => {
    const submit = wrapLocalLoader(async () => {
      const res = await apiCalls({
        method: "post",
        data,
        url: `/challenges`,
      });

      if (res) {
        closeModal();

        history.push(`/challenges/${res.data.id}`);

        await getChallenges();
      }
    }, setLoading);

    submit();
  };

  return (
    <Modal
      open={open}
      closeModal={closeModal}
      style={{ maxHeight: "70vh" }}
      scrollable
    >
      <h2>Add New Challenge</h2>

      <form onSubmit={handleSubmit(onSubmit)}>
        <InputList control={control} register={register} name="tags" />

        <Input
          name="thumbnailImage"
          inputRef={register}
          label="Thumbnail Image"
          variant="outlined"
          fullWidth
          margin="normal"
          required
        />

        <Input
          name="name"
          inputRef={register}
          label="Name"
          variant="outlined"
          fullWidth
          margin="normal"
          required
        />

        <Input
          name="price"
          inputRef={register}
          label="free or premium"
          variant="outlined"
          fullWidth
          margin="normal"
          required
        />

        <Input
          name="level"
          inputRef={register}
          label="Level"
          variant="outlined"
          fullWidth
          margin="normal"
          type="number"
          required
        />

        <Input
          name="designId"
          inputRef={register}
          label="Design Id"
          variant="outlined"
          fullWidth
          margin="normal"
          required
        />

        <Input
          name="resourceId"
          inputRef={register}
          label="Resource Id"
          variant="outlined"
          fullWidth
          margin="normal"
          required
        />

        <Input
          name="intro"
          inputRef={register}
          label="Intro (Challenge Card)"
          variant="outlined"
          fullWidth
          margin="normal"
          rows="3"
          multiline
          required
        />

        <Input
          name="brief"
          inputRef={register}
          label="Brief (User Stories)"
          variant="outlined"
          fullWidth
          margin="normal"
          rows="6"
          multiline
          required
        />

        <Input
          name="pathSlug"
          inputRef={register}
          label="Path Slug"
          variant="outlined"
          fullWidth
          margin="normal"
          required
        />


        <div className={styles.addChallengeModal_buttonRow}>
          <Button type="submit" loading={loading} aria-label="submit">
            Submit
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default AddChallengeModal;
